import _ from 'lodash';

export default function EquipmentImagesModalController(
  $scope,
  $rootScope,
  $uibModalInstance,
  items,
  index,
  users,
  $timeout,
  equipId,
  MediaService,
  EquipmentService,
  profilePictureId,
  onDeleteImageCallback,
  $uibModal,
  gettextCatalog,
  $filter,
  photoSwipeService
) {
  'ngInject';

  $scope.isLoading = true;
  $scope.images = [];
  $scope.gallery = {};
  $scope.profilePictureId = profilePictureId;
  $scope.isProfileImage = false;
  $scope.errorFlag = false;
  $scope.errorText = '';

  $scope.onLoad = function() {
    //build object the photoswipe requires
    _.forEach(items, function(e) {
      //if object has attributes as an innr object , we need for fold it in the parent object
      const {attributes, ...rest} = e;
      e = {...rest, ...attributes};
      let image = {};
      image.src = e.href;
      image.w = 0;
      image.h = 0;
      image.id = e.id;
      image.title = '';
      image.initialPosition = {
        x: 0,
        y: 0
      };

      if (e.description) {
        image.title += '<br />' + e.description;
      }

      if (e.createdAt) {
        image.title +=
          '<br />' +
          gettextCatalog.getString('Created At: {{date}}', {
            date: $filter('TableDateFilter')(e.createdAt)
          });
      }

      if (e.updatedAt) {
        image.title +=
          '<br />' +
          gettextCatalog.getString('Updated At: {{date}}', {
            date: $filter('TableDateFilter')(e.updatedAt)
          });
      }

      $scope.images.push(image);
    });

    let pswpElement = document.querySelectorAll('.pswp')[0];

    $scope.gallery = photoSwipeService.init(pswpElement, $scope.images, index);

    $scope.gallery.listen('gettingData', function(i, item) {
      if (item) {
        if (item.w < 1 || item.h < 1) {
          let img = new Image();
          img.onload = function() {
            item.w = this.width;
            item.h = this.height;
            $scope.gallery.updateSize(true);
          };

          img.src = item.src;
          img.id = item.id;
        }
      }
    });

    $scope.gallery.listen('afterChange', function() {
      $scope.errorFlag = false;
      checkProfileImage();
    });

    $scope.gallery.init();

    $scope.isLoading = false;
  };

  $timeout(function() {
    $scope.onLoad();
  }, 1000);

  $scope.cancel = function() {
    $uibModalInstance.close($scope.profilePictureId);
  };

  $scope.deleteImage = function() {
    $scope.errorFlag = false;

    let currIndex = $scope.gallery.getCurrentIndex();

    let imageId = $scope.images[currIndex].id;

    $uibModal
      .open({
        animation: true,
        template: require('./equipment-images-delete.modal.html'),
        controller: 'EquipmentImagesDeleteModalController',
        size: 'md'
      })
      .result.then(function(response) {
        if (response === 'cancel') {
          return;
        } else if (response === 'ok') {
          MediaService.deleteImage(imageId)
            .then(function() {
              onDeleteImageCallback(imageId, currIndex);

              //if profilepicture of asset remove from UI
              if (profilePictureId === imageId) {
                $rootScope.$broadcast('equipmentProfileImage', null);
              }

              //need in order to update the slide location after deleting
              $scope.gallery.goTo(0);

              items.splice(currIndex, 1); //keep track of whats delete to pass back to details page

              //if the user has deleted all images close the view modal
              if (items.length === 0) {
                $uibModalInstance.close();
              } else {
                $scope.images.splice(currIndex, 1);

                $timeout(function() {
                  $scope.gallery.invalidateCurrItems();
                  $scope.gallery.updateSize(true);
                }, 1);
              }
            })
            .catch(function(error) {
              let errorMsg = gettextCatalog.getString(
                'An error occurred while deleting the image. Please try again later.'
              );
              if (error) {
                if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
                  errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
                } else if (!!error.status && !!error.statusText) {
                  errorMsg =
                    gettextCatalog.getString('An error occurred while deleting the image: ') +
                    (error.status.toString() + ' - ' + error.statusText.toString());
                }
              }
              $scope.errorText = errorMsg;
              $scope.errorFlag = true;
            });
        }
      });
  };

  function getUsername(imageObj) {
    let username = '';
    if (imageObj.updatedBy) {
      username = _.find(users, function(e) {
        return e.id === imageObj.updatedBy.data.id;
      });
    }

    if (username) {
      return username.username;
    } else {
      return username;
    }
  }

  function checkProfileImage() {
    let currIndex = $scope.gallery.getCurrentIndex();

    if ($scope.images[currIndex].id === $scope.profilePictureId) {
      $scope.isProfileImage = false;
    } else $scope.isProfileImage = true;

    $timeout(function() {
      $scope.$apply();
    }, 1);
  }

  $scope.setAsDefault = function() {
    $scope.isLoading = true;
    $scope.errorFlag = false;
    let imageObj = items[$scope.gallery.getCurrentIndex()];

    EquipmentService.patchEquipmentProfileImage(equipId, imageObj)
      .then(function() {
        $scope.isLoading = false;

        profilePictureId = imageObj.id;
        $scope.profilePictureId = imageObj.id;

        checkProfileImage();

        $rootScope.$broadcast('equipmentProfileImage', imageObj);
      })
      .catch(function(error) {
        let errorMsg = gettextCatalog.getString(
          'An error occurred while setting the default image. Please try again later.'
        );
        if (error) {
          if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
            errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
          } else if (!!error.status && !!error.statusText) {
            errorMsg =
              gettextCatalog.getString('An error occurred while setting the default image: ') +
              (error.status.toString() + ' - ' + error.statusText.toString());
          }
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.isLoading = false;
      });
  };
}
